import '../snippets/face-measurement';
(function videoHero() {
    var selectors = {
        srcData: "src",
        mobileSrcData: "mobilesrc",
        desktopSource: "#source_desktop",
        mobileSource: "#source_mobile",
        playPauseVideo: "[data-play-pause-video]",
        playButton: "[data-play-button]",
        pauseButton: "[data-pause-button]",
    };
    var width = window.innerWidth;
    if (document.querySelector(selectors.desktopSource) || document.querySelector(selectors.mobileSource)) {
        window.addEventListener('load', function () {
            if (width > 767) {
                var desktopdata = document.querySelector(selectors.desktopSource).dataset[selectors.srcData];
                document.querySelector(selectors.desktopSource).setAttribute("src", desktopdata);
                document.querySelector(selectors.desktopSource).parentElement.load();
                document.querySelector(selectors.desktopSource).parentElement.setAttribute("autoplay", "true");
                document.querySelector(selectors.desktopSource).parentElement.play();
            }
            else {
                var mobileData = document.querySelector(selectors.mobileSource).dataset[selectors.mobileSrcData];
                document.querySelector(selectors.mobileSource).setAttribute("src", mobileData);
                document.querySelector(selectors.mobileSource).parentElement.load();
                document.querySelector(selectors.mobileSource).parentElement.setAttribute("autoplay", "true");
                document.querySelector(selectors.mobileSource).parentElement.play();
            }
        });
        document.querySelectorAll(selectors.playPauseVideo).forEach(function (button) {
            return button.addEventListener('click', function () {
                return button.parentElement.parentElement.parentElement.querySelectorAll('video').forEach(function (video) {
                    if (video.paused) {
                        video.play();
                        document.querySelector(selectors.playButton).classList.add('hidden');
                        document.querySelector(selectors.pauseButton).classList.remove('hidden');
                    }
                    else {
                        video.pause();
                        document.querySelector(selectors.pauseButton).classList.add('hidden');
                        document.querySelector(selectors.playButton).classList.remove('hidden');
                    }
                });
            });
        });
    }
})();
